import { favouriteConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

//  ====================================
//          shortlisting
//  ====================================

// shortlist candidate
export const create_shortlisting_candidate_by_hm_action =
  (data) => async (dispatch) => {
    dispatch({
      type: favouriteConstants.CREATE_SHORTLIST_CANDIDATE_BY_HM_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.hiringManager.favouriteCandidate,
        data
      );
      if (response.status) {
        dispatch({
          type: favouriteConstants.CREATE_SHORTLIST_CANDIDATE_BY_HM_ACTION_SUCCESS,
          payload: response.data,
        });
        showSuccessMessage(response.data.msg);
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: favouriteConstants.CREATE_SHORTLIST_CANDIDATE_BY_HM_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//update shortlisted candidate
export const update_shortlisted_candidate_by_hm_data_action =
  (data, id) => async (dispatch) => {
    dispatch({
      type: favouriteConstants.UPDATE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.hiringManager.updateFavouriteCandidate.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: favouriteConstants.UPDATE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: favouriteConstants.UPDATE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//deletes shortlisted candidate
export const hm_delete_shortlisted_candidate_by_id_action =
  (id) => async (dispatch) => {
    dispatch({
      type: favouriteConstants.DELETE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.delete(
        config.hiringManager.deleteFavouriteCandidate.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: favouriteConstants.DELETE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: favouriteConstants.DELETE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

// get shortlist candidates list 
export const get_shortlisted_candidates_by_hm_action =
  (id) => async (dispatch) => {
    dispatch({
      type: favouriteConstants.GET_SHORTLISTED_CANDIDATES_DATA_BY_HM_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.hiringManager.getAllFavouriteCandidates}`
      );
      if (response.status) {
        dispatch({
          type: favouriteConstants.GET_SHORTLISTED_CANDIDATES_DATA_BY_HM_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: favouriteConstants.GET_SHORTLISTED_CANDIDATES_DATA_BY_HM_ACTION_FAILURE,
        payload: e?.msg,
      });
      showWarningMessage(e?.msg);
    }
  };


